
































import { Component, Prop, Vue } from "vue-property-decorator";
import { FView } from '@/core/FView';
import App from '@/App.vue';
import Loading from '@/components/Loading.vue';

@Component({
  components: { Loading }
})
export default class Login extends Vue {
  isLoading: boolean = false;
  formLogin: string = "";
  formPassword: string = "";

  submitForm(event:Event) {
    if (this.formLogin.length > 0 && this.formPassword.length > 0) {
      this.isLoading = true;
      this.getApp().hideError();

      FView.Get().authManager.CheckCredentials(event.srcElement as HTMLFormElement)
        .then(_ => this.getApp().SwitchDashboardState() )
        .catch(err => this.getApp().showError(err))
        .finally(() => this.isLoading = false);
    }
  }

  private getApp() : App {
    return this.$parent as App;
  }
}
